import { useState } from 'react';

import { ITextOnMediaViewModel } from 'Scripts/Types/Litium';

import Markup from 'Components/Markup';

interface TextOnMediaViewModelProps extends ITextOnMediaViewModel {
    hiddenPlaceholder?: boolean;
    readMoreText?: string;
    readLessButtonText?: string;
    readMoreButtonText?: string;
    readMoreTextWidth?: number;
    readMoreButtonAlignment?: string;
}

const CreativeTextOnMedia = ({
    text,
    textWidth,
    horizontalPosition,
    verticalPosition,
    hiddenPlaceholder,
    readMoreText,
    readLessButtonText,
    readMoreButtonText,
    readMoreTextWidth,
    readMoreButtonAlignment,
}: TextOnMediaViewModelProps) => {
    const mapStringToAxis = {
        center: '50%',
        left: '0%',
        right: '100%',
        bottom: '100%',
        top: '0%',
    };

    const [showReadMoreText, setOpenReadMore] = useState(false);

    const getreadMoreButtonMargin = (position: string) => {
        switch (position) {
            case 'left':
                return 'auto auto auto 0';
            case 'right':
                return 'auto 0 auto auto';
            default:
                return '0 auto';
        }
    };

    return (
        text?.value && (
            <>
                {hiddenPlaceholder && (
                    <Markup
                        style={
                            {
                                '--block-text-width': `${textWidth}%`,
                            } as React.CSSProperties
                        }
                        cssClass={`prose-block mb-0 invisible lg:w-[var(--block-text-width)] ${
                            readMoreText ? 'hidden lg:block' : ''
                        }`}
                        html={text.value}
                    />
                )}

                <div
                    className={`prose-textAlignCenter prose-block left-[var(--block-text-position-x)] top-[var(--block-text-position-y)] mb-0 w-full -translate-x-[var(--block-text-position-x)] -translate-y-[var(--block-text-position-y)] transform px-4 lg:w-[var(--block-text-width)] lg:px-0 ${
                        readMoreText
                            ? 'relative mt-4 lg:absolute lg:mt-0'
                            : 'absolute'
                    }`}
                    style={
                        {
                            '--block-text-width': `${textWidth}%`,
                            '--block-text-position-x':
                                mapStringToAxis[
                                    horizontalPosition as keyof typeof mapStringToAxis
                                ],
                            '--block-text-position-y':
                                mapStringToAxis[
                                    verticalPosition as keyof typeof mapStringToAxis
                                ],
                        } as React.CSSProperties
                    }
                >
                    <Markup
                        cssClass="prose-block mb-0 w-full lg:px-0 prose-textAlignCenter"
                        html={text.value}
                    />
                    {readMoreText && (
                        <>
                            <div
                                className={`m-auto mb-0 grid w-full overflow-hidden transition-[grid-template-rows,_visibility] duration-layout ${
                                    showReadMoreText
                                        ? 'visible grid-rows-[1fr]'
                                        : 'invisible grid-rows-[0fr]'
                                } lg:w-[var(--read-more-text-width)]`}
                                style={
                                    {
                                        '--read-more-text-width':
                                            readMoreTextWidth > 0
                                                ? `${readMoreTextWidth}%`
                                                : `100%`,
                                    } as React.CSSProperties
                                }
                            >
                                <Markup
                                    html={readMoreText}
                                    cssClass="prose-block mb-0 pt-4 px-4 lg:px-0 overflow-hidden"
                                />
                            </div>

                            <button
                                className="m-[var(--read-more-button-margin)] flex pb-4 pt-3 font-roboto font-medium"
                                onClick={() => {
                                    setOpenReadMore(!showReadMoreText);
                                }}
                                style={
                                    {
                                        '--read-more-button-margin': `${getreadMoreButtonMargin(
                                            readMoreButtonAlignment
                                        )}`,
                                    } as React.CSSProperties
                                }
                            >
                                {showReadMoreText
                                    ? readLessButtonText
                                    : readMoreButtonText}
                            </button>
                        </>
                    )}
                </div>
            </>
        )
    );
};

export default CreativeTextOnMedia;
